<!--
  ATTENTION

  This component is used partially changed on the following files
  when using the new layout (supportsNewLayout FF):

  - app/javascript/src/application/report/screens/graph-editor/components/graph-title.vue
  - app/javascript/src/application/report/screens/graph-editor/components/graph-actions.vue

  so be cautious when changing this component, as it might affect the new layout as well and might
  require changes on the above files also!
-->
<template>
  <div class="sf-pageheader sf-border-box sf-layer-border-bottom">
    <div class="sf-grid sf-grid-wide">
      <div class="sf-row">
        <div class="sf-col sf-xs-12">
          <div class="sf-level sf-level-between">
            <div class="sf-level-item">
              <div class="sf-pageheader-title sf-below-1">
                <span>{{ pageTitle }}</span>
              </div>
              <div class="sf-level">
                <a :href="reportTemplate.editUrl" class="sf-level sf-font-m">{{
                  reportTemplate.name
                }}</a
                ><span
                  v-if="reportTemplate.graphsUrl"
                  class="sf-font-s sf-c-text-light fa fa-chevron-right"
                ></span
                ><a
                  v-if="reportTemplate.graphsUrl"
                  :href="reportTemplate.graphsUrl"
                  class="sf-level sf-font-m"
                  data-walkthrough-id="chart-editor-breadcrumbs-charts"
                  >{{ I18n.t('report/template.sidebar.graphs') }}</a
                ><span
                  class="sf-font-s sf-c-text-light fa fa-chevron-right"
                ></span
                ><span class="sf-font-m sf-fwdb sf-c-text-darker">{{
                  graphCurrentTitle
                }}</span>
              </div>
            </div>
            <!-- Same container as graph-actions.vue, so both layouts space the controls alike. -->
            <div class="sf-level-item tw-flex tw-items-center tw-gap-2">
              <GraphDrawerControls
                :drawer="drawer"
                @set-pinned="setDrawerPinned({ pinned: $event })"
                @set-highlighted="setDrawerHighlighted({ highlighted: $event })"
                @confirm-replace="saveGraph({ replaceMainChart: true })"
                @cancel-replace="cancelReplaceMainChart"
              />
              <GraphLanguageSelect
                v-model="locale"
                :languages="graphAvailableLanguages"
              />
              <SfButtonDs
                v-if="isPersisted && !readOnly"
                variant="danger"
                @click="destroyWithConfirm()"
              >
                {{ I18n.t('js.report_graph.edit.destroy') }}
              </SfButtonDs>
              <SfButtonDs
                v-if="!readOnly"
                variant="primary"
                :loading="saving"
                :disabled="saveDisabled"
                data-walkthrough-id="chart-editor-save"
                @click="submit()"
              >
                {{ I18n.t('js.report_graph.edit.save') }}
              </SfButtonDs>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

import SfButtonDs from '@app/shared/vue/components/sf-button/sf-button-ds.vue'

import GraphDrawerControls from './graph-drawer-controls.vue'
import GraphLanguageSelect from './graph-language-select.vue'

const ENTER = 'Enter'
const TEXTAREA = 'TEXTAREA'

export default {
  components: { GraphDrawerControls, GraphLanguageSelect, SfButtonDs },
  computed: {
    ...mapState([
      'reportTemplate',
      'currentLocale',
      'readOnly',
      'saving',
      'drawer',
    ]),
    ...mapGetters([
      'graphCurrentTitle',
      'graphAvailableLanguages',
      'isPersisted',
      'hasUnsavedChanges',
    ]),
    // A new graph has nothing saved to compare against, so it can always be
    // saved. A persisted one can be saved once something changed.
    saveDisabled() {
      return this.isPersisted && !this.hasUnsavedChanges
    },
    pageTitle() {
      if (this.isPersisted) {
        return I18n.t('js.report_graph.edit.title.edit')
      } else {
        return I18n.t('js.report_graph.edit.title.new')
      }
    },
    locale: {
      get() {
        return this.currentLocale
      },
      set(newLocale) {
        this.setCurrentLocale({ locale: newLocale })
      },
    },
  },
  mounted() {
    if (!this.readOnly) {
      document.body.addEventListener('keyup', (event) => {
        if (event.key === ENTER && event.target.tagName !== TEXTAREA) {
          this.submit()
        }
      })
    }
  },
  methods: {
    ...mapActions([
      'setCurrentLocale',
      'deleteGraph',
      'saveGraph',
      'setDrawerPinned',
      'setDrawerHighlighted',
      'cancelReplaceMainChart',
    ]),
    destroyWithConfirm() {
      window.sfRemoveConfirm({
        name: this.graphCurrentTitle,
        onConfirm: this.deleteGraph,
      })
    },
    submit() {
      if (this.saveDisabled) return
      this.saveGraph()
    },
  },
}
</script>
